// Bundles the five FK lookup collections into id→entity Maps for cell name
// resolution. Each collection is fetched once and cached by RTK Query
// (matches the Backbone "fetch once, cache in shared storage" behavior;
// parity 127).

import { useMemo } from 'react';
import {
  useCompanies,
  useContacts,
  usePartners,
  useMfgUsers,
  useMarketTypes,
} from 'hooks/useDashboardData';
import { toMap, type LookupMaps } from 'pages/dashboard/dashboardUtils';

export function useLookupMaps(): LookupMaps {
  const { data: companies } = useCompanies();
  const { data: contacts } = useContacts();
  const { data: partners } = usePartners();
  const { data: mfgUsers } = useMfgUsers();
  const { data: marketTypes } = useMarketTypes();

  return useMemo(
    () => ({
      companies: toMap(companies),
      contacts: toMap(contacts),
      partners: toMap(partners),
      mfgUsers: toMap(mfgUsers),
      marketTypes: toMap(marketTypes),
    }),
    [companies, contacts, partners, mfgUsers, marketTypes]
  );
}
